import React from 'react';
import { FaTimes } from 'react-icons/fa';

export default function ClassFilter({ searchTerm, setSearchTerm, selectedGrade, setSelectedGrade }) {
    return (
        <div className="bg-white p-4 rounded-3xl border border-gray-100 shadow-sm flex flex-col md:flex-row gap-4 items-center">
            <div className="relative flex-1 w-full">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <FaTimes className="text-gray-400 rotate-45" size={14} />
                </div>
                <input
                    type="text"
                    placeholder="Search by class name or teacher..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 bg-gray-50 border-none rounded-2xl text-sm font-medium focus:ring-2 focus:ring-blue-500 transition-all outline-none"
                />
            </div>
            <div className="flex gap-2 w-full md:w-auto">
                <select
                    value={selectedGrade}
                    onChange={(e) => setSelectedGrade(e.target.value)}
                    className="flex-1 md:w-40 bg-gray-50 border-none rounded-2xl text-sm font-bold text-gray-500 py-3 px-4 focus:ring-2 focus:ring-blue-500 outline-none"
                >
                    <option value="All">All Grades</option>
                    {[10, 11, 12, 13].map(g => <option key={g} value={g}>Grade {g}</option>)}
                </select>
            </div>
        </div>
    );
}
